import { VideosRecipientsParams } from './getVideosRecipients';

export const VIDEO_RECIPIENTS = 'VIDEO_RECIPIENTS';
export const recipientsKeys = {
  video_recipients: (videoId: string, params: VideosRecipientsParams) =>
    [VIDEO_RECIPIENTS, videoId, params] as const,
};
